import {request, serviceUrl} from "@/utils/request";

//获取门禁数据
export function getEntranceGuardList(current, size, apiId) {
  return request({
    url: serviceUrl.iotboxService + '/iot/box/business/entranceguard/list',
    params: {current, size, apiId}
  })
}

//开门(中控)
export function openZkDoor(deviceId) {
  return request({
    url: serviceUrl.iotboxService + '/zkteco/xface600/openDoor',
    params: {deviceId}
  })
}

// 海康门禁
export function getHikvisionAccessControl(index, max, deviceId) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/petrol/gate/log/list',
    data: {index, max, deviceId}
  })
}